<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/transfer-centers/create">{{ $t("transferCentersPage.new") }}</v-btn>
    <DataTable :url="'transfer-center'" ref="transfer_centers" :perPage="'25'" :enable-add="false" :enable-edit="false"
      :enable-delete="false" :formatter="formatter" :actions-extra-main="actions"
     :fields-hidden-main="['location', 'governorate_id']" :titles="titles" :title='$t("transferCentersPage.pageTitle")'/>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "TransferCenters",
  title() {
    return this.$t("transferCentersPage.pageTitle");
  },
  components: { DataTable },
  computed: {
    titles() {
      return {
        id: this.$t("transferCentersPage.id"),
        name: this.$t("transferCentersPage.name"),
        account_code: this.$t("transferCentersPage.accountCode"),
        phone_number: this.$t("transferCentersPage.phoneNumber"),
        username: this.$t("transferCentersPage.email"),
        address: this.$t("transferCentersPage.address"),
        governorate_name: this.$t("transferCentersPage.governorate"),
        balance: this.$t("transferCentersPage.balance"),
        // Accountant doc 2026-10-03 item 1.9: company center + gift budget.
        is_company: this.$t("snapCenterGifts.isCompany"),
        gift_balance: this.$t("snapCenterGifts.giftBalance"),
        blacklisted_at: this.$t("transferCentersPage.accountStatus"),
        created_at: this.$t("transferCentersPage.creationDate"),
      };
    },

    actions() {
      return {
        edit: {
          title: this.$t("transferCentersPage.viewProfile"),
          icon: "info",
          action: (item) => {
            this.$router.push({ path: `/transfer-centers/${item.id}` });
          },
        },
      };
    },
    conditionalActions() {
      return {};
    },
    formatter() {
      const self = this;
      return {
        blacklisted_at(val) {
          if (val)
            return `
                        <i class="inactive-mark fa fa-close" style="color:red; font-size:18px"></i>
                        `;
          else
            return `
                         <i class="active-mark fa fa-check" style="color:green; font-size:18px"></i>
                        `;
        },

        balance(value) {
          return self.formatMoney(value);
        },

        is_company(value) {
          return value ? self.$t("snapCenterGifts.yes") : self.$t("snapCenterGifts.no");
        },

        gift_balance(value) {
          return self.formatMoney(value || 0);
        },

        account_code(value) {
          return value === null || value === undefined || value === "" ? "-" : value;
        },

        governorate_name(value) {
          return value === null || value === undefined || value === "" ? "-" : value;
        },

        created_at(value) {
          // Final-version doc 2026-10-05: company clock (UTC+3).
          return formatCompanyTime(value, "DD-MM-YYYY  HH:mm", "");
        },
      };
    },
  },
  methods: {
  },
};
</script>

<style scoped>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>
